import { render, staticRenderFns } from "./GameContainer.vue?vue&type=template&id=3f223e3f&scoped=true&"
import script from "./GameContainer.vue?vue&type=script&lang=ts&"
export * from "./GameContainer.vue?vue&type=script&lang=ts&"
import style0 from "./GameContainer.vue?vue&type=style&index=0&id=3f223e3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f223e3f",
  null
  
)

export default component.exports